export default __webpack_public_path__ + "static/media/File A 2-11_331 - The Energy (Full).520fbd03.mp3";